import React from 'react'
import { 
    Button
} from '@material-ui/core'
import authService from './api-authorization/AuthorizeService'

export default function BookingRejectButton({
    booking,  // from shipmentDetailPage.js
    clientId,
    selectedRows, // from shipmentTable.js
    ...props
}) {
    const handleRejectBooking = async () => {
        const bookingNumbers = (typeof selectedRows === 'function' ? selectedRows() : selectedRows)?.map(r => r.shipmentNumber) || [] // Get the actual rows from the function if selectedRows is a function
        const bookingNumbersToReject = bookingNumbers && bookingNumbers.length > 0 ? bookingNumbers : (booking ? ['S' + booking.houseBillNumber] : []) // If no rows are selected, use the booking number from the shipment detail page
            
        try {    
            const token = await authService.getAccessToken()
            const response = await fetch('api/shipments/RejectBookings', {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    ClientId: clientId,
                    BookingNumbers: bookingNumbersToReject
                })
            })
            if (!response.ok) {
                const responseObj = await response.json()
                throw new Error(responseObj.message)
            }
            alert('Booking(s) successfully rejected.')
            window.location.reload()
        } 
        catch (error) {
            alert(error.message)
        }
    }
    
    return (
        <>
            <Button 
                variant="contained" 
                color="primary" 
                onClick={handleRejectBooking}
            >
                { props.buttonTitle || 'Reject Booking' }
            </Button>
        </>
    )
}
